export enum QualifierKind {
  ConceptQualifier = 'ConceptQualifier',
  TemplateQualifier = 'TemplateQualifier',
  ValueQualifier = 'ValueQualifier',
}
